import React from 'react';
import classnames from 'classnames';

import { CompletedStepCheckmark } from 'ui-components/components/completed-step-checkmark/completed-step-checkmark';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import style from './onboard-cards.module.less';
import { useHomePageOnboardContext } from '../../home-page-onboard-context';

/**
 * @typedef {import('../../../../prop-types/intl').MessageDescriptorPropType} MessageDescriptorPropType
 * @typedef {import('../../../../prop-types/children').ChildrenPropType} ChildrenPropType
 * @typedef {object} OnboardCardProps
 * @property {ChildrenPropType} children
 * @property {boolean} isComplete
 * @property {MessageDescriptorPropType} title
 * @property {JSX.Element} headerImage
 * @property {string} store
 */

/**
 * @param {OnboardCardProps} props
 * @returns {JSX.Element}
 */
export const OnboardCard = ({ children, isComplete, title, headerImage, store }) => {
  const { isPopup } = useHomePageOnboardContext();

  return (
    <div className={style['onboard-card-container']}>
      <div className={classnames(style['onboard-card'], { [style.complete]: isComplete }, { [style['popup-card']]: isPopup })}>
        <FlexRow className={style['svg-and-percent']}>
          {headerImage}
          <CompletedStepCheckmark isComplete={isComplete} />
        </FlexRow>
        <div className={style['onboard-card-header']}>
          <Text className={style['card-title']} formattedMessageValues={{ store }} textType={TextType.H4} value={title} />
        </div>
        <FlexColumn className={style['body-and-footer']}>{children}</FlexColumn>
      </div>
    </div>
  );
};
